import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { IModuleDefinition } from '@platform/core/types';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { viewLabel } from './viewLabel';

/**
 * Підписи подань мовою інтерфейсу (viewLabel): власні подання — підписи сторінок модуля `module` (рядки його пакета),
 * стандартні — рядки рушія `views.<ключ>`. Без модуля бере рядки модуля з ModuleStringsContext.
 */
export function useViewLabel(module: IModuleDefinition | undefined): (view: string) => string {
  const { t, i18n } = useTranslation();
  const strings = useModuleStrings(module?.module.key);
  return useCallback(
    (view: string) => viewLabel(view, module, strings, (key) => (i18n.exists(`views.${key}`) ? t(`views.${key}`) : undefined)),
    [module, strings, t, i18n],
  );
}
